import { createContext, useContext } from "react"
import type { Dimensions } from "./useChartResizer"

type DimensionsProviderValue = Dimensions & {
  scale: number
  lowestTick: number
  highestTick: number
}

const DimensionsContext = createContext<DimensionsProviderValue | null>(null)

type DimensionsProviderProps = {
  children: React.ReactNode
  value: DimensionsProviderValue
}

export function DimensionsProvider({ children, value }: DimensionsProviderProps) {
  return <DimensionsContext.Provider value={value}>{children}</DimensionsContext.Provider>
}

export function useDimensionsContext() {
  const context = useContext(DimensionsContext)

  if (!context) {
    throw new Error("useDimensionsContext must be used within a DimensionsProvider")
  }
  return context
}
